import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ColumnsType } from 'antd/es/table';
import type { ParsedJsonUpload } from '../types';

export function usePipelineUploadColumns() {
  const { t } = useTranslation('pipelineDebug');

  const columns: ColumnsType<ParsedJsonUpload> = useMemo(
    () => [
      {
        title: t('upload.table.file'),
        dataIndex: 'fileName',
        key: 'fileName',
      },
      {
        title: t('upload.table.records'),
        key: 'records',
        render: (_, record) => record.records.length,
      },
    ],
    [t],
  );

  return { columns };
}
